<template>
    <b-container class="wrapper h-100" fluid>
        <b-row class="first h-100" align-v="center" align-h="center">
            <b-col col xs="10" sm="10" md="10" xl="8" lg="8">
                <b-row class="h-75" align-v="center" align-h="center">
                    <b-col  cols="12">
                        <h1 class="title">Innovación basada en datos</h1>
                        <h2 class="description">Generamos certidumbre para enfocar los recursos en ideas ganadoras al invertir en innovación.</h2>
                    </b-col>
                </b-row>
                <b-row class="h-25" align-v="center" align-h="center">
                    <b-col cols="12">
                        <p class="head">Conoce más</p>
                        <p class="icon my-0"><b-icon icon="arrow-down"></b-icon></p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row class="fifth h-100" align-v="center" align-h="center">
        <b-row class="slider-bgnd">
        <b-row class="slider-cover" align-v="start" align-h="center">
            <b-col col xs="8" sm="8" md="8" xl="8" lg="8">
                <p class="head"><br>Casos de éxito:<br><br></p>

                <b-row class="success-slider1" align-v="start" align-h="start">
                    <b-col col xs="8" sm="8" md="6" xl="6" lg="6">
                        <h2>Pilotos de digitalización</h2>
                        <br>
                        <p class="text"><br>Antes de invertir grandes sumas en nuevos modelos de servicio, identificamos las <span>oportunidades más valiosas</span> para la empresa.
                            <br>Como resultado se corrieron los pilotos con más potencial de implementarse con su mercado meta y <span>crear nuevos servicios</span>.</p>
                        <p>&nbsp;</p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        </b-row>
        </b-row>
        <b-row class="fourth" align-v="center" align-h="center">
            <b-col col xs="8" sm="8" md="8" xl="8" lg="8">
                <p class="head">Ellos han confiado en nosotros:<br><br></p>
                <div class="animation-wrap">
                    <b-row class="client-slider0"></b-row>
                    <b-row class="client-slider client-slider1" align-v="center" align-h="center">
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-GBM.png" alt="GBM">
                        </b-col>
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-KIO.png" alt="KIO Networks">
                        </b-col>
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-BBVA.png" alt="BBVA">
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
        <b-row class="sixth" align-v="center" align-h="center">
            <b-col class="section-wrapper" col xs="8" sm="8" md="8" xl="8" lg="8">
                <b-row class="no-margin" align-v="center" align-h="center">
                    <b-col col xs="12" sm="12" md="12" xl="12" lg="12">
                        <p class="head no-margin">¿Quieres hablar<br>con un experto?</p>
                    </b-col>
                </b-row>
                <b-row class="no-margin" align-v="center" align-h="center">
                    <b-col col xs="12" sm="12" md="12" xl="12" lg="12">
                        <p class="image-placeholder">
                            <img src="../assets/ozmo-agencia-innovacion-organizacional.png" alt="ozmo designer">
                        </p>
                    </b-col>
                </b-row>
                <b-row align-v="center" align-h="center">
                    <b-col class="align-center" col xs="12" sm="12" md="12" xl="12" lg="12">
                        <b-button class="ozmo-btn-outline-green" @click="launchContact">Contáctanos</b-button>
                    </b-col>
                </b-row>
                <b-row align-v="center" align-h="center">
                    <b-col class="align-center" col xs="12" sm="12" md="12" xl="12" lg="12">
                        <b-button class="ozmo-btn-outline" @click="launchFontacto">55 8526 3310</b-button>
                    </b-col>
                </b-row>
                <b-row class="social" align-v="center" align-h="center">
                    <b-col col xs="3" sm="3" md="3" xl="3" lg="3">
                        <b-row align-v="center" align-h="center">
                            <b-col class="social-img" col xs="3" sm="3" md="3" xl="3" lg="3">
                                <a href="https://www.facebook.com/OZMOmx" target="_blank"><img src="../assets/social/ozmo-facebook.png" alt="facebook"></a>
                            </b-col>
                            <b-col class="social-img" col xs="3" sm="3" md="3" xl="3" lg="3">
                                <a href="https://www.linkedin.com/company/ozmo-futures-design" target="_blank"><img src="../assets/social/ozmo-linkedin.png" alt="LinkedIn"></a>
                            </b-col>
                            <b-col class="social-img" col xs="3" sm="3" md="3" xl="3" lg="3">
                                <a href="https://twitter.com/OzmoFutures" target="_blank"><img src="../assets/social/ozmo-twitter.png" alt="Twitter"></a>
                            </b-col>
                            <b-col class="social-img" col xs="3" sm="3" md="3" xl="3" lg="3">
                                <a href="https://www.instagram.com/ozmofutures" target="_blank"><img src="../assets/social/ozmo-instagram.png" alt="Instagram"></a>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row align-v="center" align-h="center">
                    <b-col col xs="12" sm="12" md="12" xl="12" lg="12">
                        <p class="footnote">© 2020 Ozmo Futures Design</p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

import { gsap } from "gsap"
import { TimelineLite, Sine } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

import * as typeformEmbed from "@typeform/embed"

gsap.registerPlugin(ScrollTrigger)

import { eventBus } from '../main'

export default {
    name: 'IBD',
    data() {
        return {}
    },
    metaInfo() {
        return {
            title: 'Innovación organizacional basada en datos | Ozmo',
            meta: [
                {name: 'description', content: 'Como agencia de innovación identificamos oportunidades para que tus recursos sean invertidos en ideas ganadoras que te hagan crecer. ¡Contáctanos!'},
                {name: 'keywords', content: 'Innovación organizacional basada en datos, consultora en innovación estratégica, consultora de innovación, agencia de transformación estratégica, consultora de cultura organizacional, consultoría en transformación para empresas, consultoría en cultura organizacional, proveedores de design thinking, agencias de investigación de usuarios, talleres para diseñar experiencias, consultoras con experiencia en área de capital humano, consultoras en innovación con experiencia sector financiero, agencia de innovación empresarial'},
                {name: 'robots', content: 'index,follow'},
                {name: 'viewport', content: 'width=device-width,initial-scale=1,user-scalable=no' },
                {charset: 'utf-8' },
                {property: 'og:title', content: 'Innovación organizacional basada en datos | Ozmo'},
                {property: 'og:site_name', content: 'Ozmo | Diseño de futuros'},
                {property: 'og:description', content: 'Como agencia de innovación identificamos oportunidades para que tus recursos sean invertidos en ideas ganadoras que te hagan crecer. ¡Contáctanos!'},
                {property: 'og:url', content: 'https://ozmo.mx'},
                {property: 'og:type', content: 'website'},
                {property: 'og:image', content: 'https://s3-us-west-2.amazonaws.com/cdn.ozmo.mx/ozmo_coral.png'}
            ]
        }
    },
    methods: {
        goto(navigation) {
            eventBus.$emit('gotoNavigation', navigation)
        },
        launchProspector() {
            typeformEmbed.makePopup(
                'https://ozmomx.typeform.com/to/vwqXW6',
                {
                    mode: 'drawer_right',
                    autoOpen: true,
                    autoClose: 15,
                    hideScrollbars: true,
                    onSubmit: function () {}
                }
                )
        },
        launchContact() {
            typeformEmbed.makePopup(
                // `https://ozmomx.typeform.com/to/dTWHb81Q?source=web-${this.$route.name}`,
                // 'https://ozmomx.typeform.com/to/YPa8WK93?utm_source=website&utm_medium=section&utm_campaign=website2022&utm_content=IBD',
                'https://www.cognitoforms.com/Kinit1/ContactoWeb?entry={"Leads":{"Ref":"website-IBD"}}',
                {
                    mode: 'drawer_right',
                    autoOpen: true,
                    autoClose: 15,
                    hideScrollbars: true,
                    onSubmit: function () {}
                }
                )
        },
        launchFontacto() {
            window.location='tel:+525585263310'
            this.$gtag('event', 'clic', {
                'event_category': 'telefono',
                'event_label': 'exitoso',
                'value': 'exitoso'
            });
        }
    },
    mounted() {
        // const { msg1, msg2 } = this.$refs
        const timeline_first = new TimelineLite({
            // scrollTrigger: {
            //     trigger: ".first"
            // }
        })

        timeline_first.fromTo('h1.title', 1, {x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'block',
            autoAlpha: 1,
            x: 0
        }).fromTo('h2.description', 1, {x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'block',
            autoAlpha: 1,
            x: 0
        })

        //////////////////////////////////////////////////

        const timeline_fourth = new TimelineLite({
            // scrollTrigger: {
            //     trigger: ".fourth"
            // }
        })

        timeline_fourth.fromTo('.client-slider1', 2, {display:'none',autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'flex',
            autoAlpha: 1,
        })

        //////////////////////////////////////////////////


        const timeline_fifth = new TimelineLite({
            // scrollTrigger: {
            //     trigger: ".fifth"
            // }
        })

        timeline_fifth.to('.slider-cover', 1, {
            ease: Sine.easeInOut,
            backgroundImage: "linear-gradient(to right, transparent, transparent)"
        }).fromTo('.success-slider1', 1, {display:'none',x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'flex',
            autoAlpha: 1,
            x: 0
        })

    },
    created() {
        eventBus.$emit('displayOverlay')
    }
}
</script>

<style scoped lang="stylus">

.msg2,.msg3,.msg4,.msg5,.msg6,.msg7,.msg8
    display none

.animation-wrap
    position relative

.wrapper
    // background-image url('../assets/bg_home.jpeg')
    // background-repeat no-repeat
    // background-size cover
    // background-color black
    width 100vw
    overflow-x hidden
    overflow-y scroll

    .first
        background-image url(../assets/service-background.jpg)
        background-size cover
        background-repeat no-repeat
        background-position center center

        h1  
            margint-top 5rem
            text-align left
            line-height 88px
            txt_style($archia-m, 80px, #FFFFFF)
            margin-bottom 5rem
        
        h2
            text-align left
            txt_style($archia-m, 32px, #FFFFFF)
            margin-bottom 10rem
        
        .head
            text-align center
            txt_style($archia-m, 16px, #FFFFFF)

        .icon
            text-align center
            txt_style($archia-m, 40px, #FFFFFF)
            padding-bottom 5rem

    .fourth
        background-color $ozmo-coral
        padding-top 20rem
        padding-bottom 20rem

        .head
            text-align center
            txt_style($archia-m, 48px, #FFFFFF)

        .client-slider
            position absolute
            top 0
            right 0
            bottom 0
            left 0
            margin 0 auto

        .client-slider0
            height 200px

        .client-img
            text-align center
                
            img
                height 200px
    
    .fifth
        background-color #000000

        .slider-bgnd
            background-image url(../assets/caso-de-exito-innovacion-basada-en-datos.jpg)
            background-repeat no-repeat
            background-size cover
            background-position center center
            width 100%
            height 100%


        .slider-cover
            // background-image linear-gradient(to right, #000000, #000000)
            width 100%
            height 100%
            margin 0


        .head
            txt_style($archia-m, 48px, #FFFFFF)

        h2
            txt_style($archia-m, 44px, $ozmo-green)

        .text
            txt_style($worksans-r, 20px, #FFFFFF)

        img
            width 50%
         

    .sixth
        background-color black
        padding-top 10rem
        padding-bottom 10rem

        button
            font-size 28px !important
            width 300px

        .row
            margin-top 5rem
            margin-bottom 5rem

        .row:last-child
            margin-bottom 0

        .head
            text-align center
            txt_style($archia-m, 48px, #FFFFFF)

        .footnote
            text-align center
            txt_style($worksans-r, 16px, #FFFFFF)

        .social

            .social-img

                img
                    width 100%

        .image-placeholder
            text-align center

            img
                width 40%        
                
@media screen and (max-width : 768px)

    .wrapper

        .first

            h1  
                margint-top 5rem
                text-align center
                line-height 44px
                txt_style($archia-m, 38px, #FFFFFF)
                margin-bottom 5rem
            
            h2
                text-align center
                txt_style($archia-m, 22px, #FFFFFF)
                margin-bottom 10rem
            
            .head
                text-align center
                txt_style($archia-m, 16px, #FFFFFF)

            .icon
                text-align center
                txt_style($archia-m, 38px, #FFFFFF)
                padding-bottom 5rem

        .fourth
            padding-top 10rem
            padding-bottom 20rem

            .head
                text-align center
                txt_style($archia-m, 32px, #FFFFFF)

            .client-slider
                position absolute
                top 0
                right 0
                bottom 0
                left 0
                margin 0 auto

            .client-slider0
                height 140px

            .client-img
                text-align center
                    
                img
                    height 140px
        
        .fifth

            .slider-bgnd
                background-position left

            .head
                margin-left .5 rem
                txt_style($archia-m, 36px, #FFFFFF)

            h2
                margin-left .5 rem
                txt_style($archia-m, 36px, $ozmo-green)

            .text
                margin-left .5 rem
                txt_style($worksans-r, 18px, #FFFFFF)

            img
                width 50%
            

        .sixth
            button
                font-size 18px !important
                width 300px

            .head
                txt_style($archia-m, 32px, #FFFFFF)

            .footnote
                txt_style($worksans-r, 12px, #FFFFFF)

            .social
                width  64%
                margin-left 20%

                .social-img

                    img
                        width 80%

            .image-placeholder
                text-align center

                img
                    width 80%

@media screen and (width : 768px) and (height : 1024px)

    .wrapper

        .first

            h1  
                line-height 78px
                txt_style($archia-m, 70px, #FFFFFF)
            
            h2
                txt_style($archia-m, 32px, #FFFFFF)
            
            .head
                txt_style($archia-m, 16px, #FFFFFF)

            .icon
                text-align center
                txt_style($archia-m, 40px, #FFFFFF)
                padding-bottom 5rem

        .fourth
            .client-slider0
                height 140px

            .client-img
                text-align center
                    
                img
                    height 140px
        
        .fifth
            .head
                txt_style($archia-m, 44px, #FFFFFF)

            h2
                txt_style($archia-m, 44px, $ozmo-green)

            .text
                txt_style($worksans-r, 22px, #FFFFFF)

            img
                width 50%
            

        .sixth

            .social

                .social-img

                    img
                        width 200%

            .image-placeholder
                text-align center

                img
                    width 100%  
</style>
